import { createFeatureActionNamer } from '../../../../redux/action-name';

const getActionName = createFeatureActionNamer('information-record');
export const ADD_INFORMATION_RECORD = getActionName('ADD_INFORMATION_RECORD');
export const UPDATE_INFORMATION_RECORD = getActionName('UPDATE_INFORMATION_RECORD');
export const DELETE_INFORMATION_RECORD = getActionName('DELETE_INFORMATION_RECORD');
export const SUBMIT = getActionName('SUBMIT');
